import { useEffect, useRef } from 'react';

const useUnmount = (destructor: () => void) => {
  const effectRef = useRef(false);

  useEffect(() => {
    if (effectRef.current) {
      return () => {
        destructor();
      };
    }
    effectRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effectRef.current]);
};

export default useUnmount;
